export default __webpack_public_path__ + "static/media/pdfPortfolioThumbnail.ee7ab5b2.svg";